import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./tracker";

/** Records a page view on every route change. Must be rendered inside <Router>. */
export function ActivityTracker(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
